<template>
  <div>
    <a-card style="width: 100%; text-align: center">
      <div class="table-page-search-wrapper">
        <a-form layout="inline"
                style="margin: 20px 0px 0px 20px">
          <a-row :gutter="12">
            <a-col :md="6"
                   :sm="12">
              <a-form-item label="设备名称">
                <a-input v-model="query.deviceName"
                         placeholder="请输入设备名称"
                         allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6"
                   :sm="12">
              <a-form-item label="报警类型">
                <a-select placeholder="请选择报警类型"
                          v-model="query.malfunctionType"
                          allow-clear>
                  <a-select-option value="0"> 报警 </a-select-option>
                  <a-select-option value="1"> 故障 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6"
                   :sm="12">
              <a-form-item label="处理状态">
                <a-select placeholder="请选择处理状态"
                          v-model="query.disposeResult"
                          @change="handleChangeleve">
                  <a-select-option v-for="(item, index) in resultType"
                                   :key="index"
                                   :value="item">
                    <span v-if="item == 0">待处理</span>
                    <span v-else>已处理</span>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6"
                   :sm="12"
                   style="display: flex">
              <a-form-item>
                <a-button type="primary"
                          @click="queryList">查询</a-button>
              </a-form-item>
              <a-form-item style="margin-left: 12px">
                <a-button @click="resetList">重置</a-button>
              </a-form-item>
              <a-button type="danger"
                        style="margin-left: 12px"
                        @click="deleteSelectRow()">删除</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table rowKey="id"
               :scroll="{ x: 2200 }"
               :columns="columns"
               :data-source="list"
               :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
               :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
               :pagination="pagination"
               @change="pageChange"
               bordered>
        <span slot="type"
              slot-scope="text">
          <span v-if="text == 0">报警</span>
          <span v-else>故障</span>
        </span>
        <span slot="actiontype"
              slot-scope="text">
          <span v-if="text == 0"><a-tag color="rgb(255, 99, 71)">待处理</a-tag></span>
          <span v-else><a-tag color="rgb(50, 205, 50)">已处理</a-tag></span>
        </span>
        <span slot="malfunctionLevel"
              slot-scope="text">
          <span v-if="text == '中等'"><a-tag color="#f98303">{{ text }}</a-tag></span>
          <span v-else-if="text == '一般'"><a-tag color="#52c41a">{{ text }}</a-tag></span>
          <span v-else><a-tag color="#f5222d">{{ text }}</a-tag></span>
        </span>
        <span slot="Operation"
              slot-scope="text, record">
          <a @click="Deal(record.id)"
             style="margin-right: 10px"
             :disabled="record.disposeResult == 1">处理</a>
          <a @click="addOrUpdateHandle(record.id)">标记</a>
        </span>
      </a-table>
      <a-modal title="标记报警级别"
               okText="标记"
               width="50%"
               :visible="visible"
               :confirm-loading="confirmLoading"
               @ok="handleOk"
               @cancel="handleCancel">
        <a-form :label-col="{ span: 5 }"
                :wrapper-col="{ span: 12 }">
          <a-select v-model="level"
                    @change="handleChange">
            <a-select-option v-for="(item, index) in typelist"
                             :key="index"
                             :value="item">
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form>
      </a-modal>
      <a-modal title="处理报警"
               okText="处理"
               width="50%"
               :visible="showdeal"
               @ok="handleDealOk"
               @cancel="handleDealCancel">
        <a-form :form="form"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 12 }">
          <a-form-item label="处理人">
            <a-input v-decorator="['processor', { rules: [{ required: true, message: '请输入处理人!' }] }]" />
          </a-form-item>
          <a-form-item label="报警描述">
            <a-input v-decorator="['malfunctionDescribe', { rules: [{ required: true, message: '请输入报警描述!' }] }]" />
          </a-form-item>
          <!-- <a-form-item label="处理结果">
            <a-select
              v-decorator="['disposeResult', { rules: [{ required: true, message: '请选择处理结果!' }] }]"
              placeholder="选择处理结果"
              @change="handleSelectChange"
            >
              <a-select-option :value="0"> 待处理 </a-select-option>
              <a-select-option :value="1"> 已处理 </a-select-option>
            </a-select>
          </a-form-item> -->
          <a-form-item label="处理方式">
            <a-input v-decorator="['processMode', { rules: [{ required: true, message: '请输入处理方式!' }] }]" />
            <!-- <a-select
             v-decorator="['processMode', { rules: [{ required: true, message: '请选择处理方式!' }] }]"
             placeholder="选择处理方式"
             @change="handleDealSelectChange"
           >
             <a-select-option value="自行处理"> 自行处理 </a-select-option>
             <a-select-option value="他人处理"> 他人处理 </a-select-option>
           </a-select>  -->
          </a-form-item>
        </a-form>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import mixinViewModule from '@/mixin/common'

export default {
  mixins: [mixinViewModule],
  data () {
    return {
      id: '',
      level: '选择报警级别',
      showdeal: false,
      queryUrl: '/pipe-network/water_works_malfunctions/page',
      deleteUrl: '/pipe-network/water_works_malfunctions',
      modifyUrl: '/pipe-network/water_works_malfunctions',
      visible: false,
      confirmLoading: false,
      list: [],
      query: {
        deviceName: '',
        malfunctionType: '',
        disposeResult: 0,
        sysType: 3,
        tenantId: this.$store.state.user.info.tenantId
      },
      resultType: [0, 1],
      typelist: ['重要', '中等', '一般'],
      form: this.$form.createForm(this, { name: 'coordinated' }),
      columns: [
        {
          title: '设备名称',
          width: 100,
          dataIndex: 'deviceName',
          align: 'center'
        },
        {
          title: '参数名称',
          width: 100,
          dataIndex: 'parameterName',
          align: 'center'
        },
        {
          title: '参数值',
          width: 100,
          dataIndex: 'dataValue',
          align: 'center'
        },
        {
          title: '报警值',
          width: 100,
          dataIndex: 'alarmValue',
          align: 'center'
        },
        {
          title: '报警原因',
          width: 100,
          dataIndex: 'malfunctionCause',
          align: 'center'
        },
        {
          title: '报警类型',
          width: 60,
          dataIndex: 'malfunctionType',
          align: 'center',
          scopedSlots: { customRender: 'type' }
        },
        {
          title: '报警时间',
          width: 180,
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: '报警级别',
          width: 60,
          dataIndex: 'malfunctionLevel',
          align: 'center',
          scopedSlots: { customRender: 'malfunctionLevel' }
        },
        {
          title: '处理状态',
          width: 60,
          dataIndex: 'disposeResult',
          align: 'center',
          scopedSlots: { customRender: 'actiontype' }
        },
        {
          title: '报警次数',
          width: 60,
          dataIndex: 'num',
          align: 'center'
        },
        {
          title: '报警描述',
          width: 100,
          dataIndex: 'malfunctionDescribe',
          align: 'center'
        },
        {
          title: '处理方式',
          width: 60,
          dataIndex: 'processMode',
          align: 'center'
        },
        {
          title: '处理人',
          width: 100,
          dataIndex: 'processor',
          align: 'center'
        },
        {
          title: '处理时间',
          width: 100,
          dataIndex: 'processorTime',
          align: 'center'
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'id',
          align: 'center',
          scopedSlots: { customRender: 'Operation' }
        }
      ]
    }
  },
  computed: {
    title () {
      return `${this.$store.getters.userInfo.tenant.shortName}智慧管理平台`
    },
    currentUser () {
      return this.$store.getters.userInfo
    },
    token () {
      return this.$store.getters.token
    }
  },
  created () { },
  methods: {
    resetList () {
      console.log('reset')
      this.query = {
        deviceName: '',
        malfunctionType: '',
        disposeResult: 0,
        sysType: 3,
        tenantId: this.$store.state.user.info.tenantId
      }
      this.pagination.current = 1
      this.selectedRows = []
      this.queryList()
      // this.loadData()
    },
    handleChangeleve (e) {
      this.query.disposeResult = e
    },
    handleChange (e) {
      const params = { id: this.id, malfunctionLevel: e }
      const header = {
        'Content-Type': 'application/json',
        Authorization: this.token
      }
      this.$http({
        url: this.modifyUrl,
        data: params,
        headers: header,
        method: 'put'
      }).then((data) => {
        // console.log(JSON.stringify(data))
        this.queryList()
        this.visible = false
        this.level = '选择报警级别'
        this.$message.success('标记成功')
      })
    },
    handleSelectChange (value) {
      console.log(value)
      this.form.setFieldsValue({ isDispose: value })
    },
    handleDealSelectChange (value) {
      console.log(value)
      this.form.setFieldsValue({
        disposeResult: value
      })
      // this.addOrUpdateForm.setFieldsValue(value)
    },
    // handleDealSelectChange(value) {
    //   console.log(value)
    //   this.form.setFieldsValue({
    //     processMode: value,
    //   })
    // },
    Deal (id) {
      this.id = id
      // this.addOrUpdateHandle(id);
      this.showdeal = true
    },
    addOrUpdateHandle (id) {
      this.id = id
      this.showModal()
    },
    showModal () {
      this.visible = true
    },
    handleDealOk () {
      console.log(this.id)
      this.form.validateFields((err, values) => {
        if (!err) {
          const year = new Date().getFullYear()
          let month = new Date().getMonth() + 1
          month = month < 10 ? '0' + month : month
          let day = new Date().getDate()
          day = day < 10 ? '0' + day : day
          let hour = new Date().getHours()
          hour = hour < 10 ? '0' + hour : hour
          let seconds = new Date().getSeconds()
          seconds = seconds < 10 ? '0' + seconds : seconds
          let minutes = new Date().getMinutes()
          minutes = minutes < 10 ? '0' + minutes : minutes
          const now = year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds
          const params = {
            id: this.id,
            // deviceName: values.disposeName,
            // malfunctionDescribe: values.alarmContent,
            // disposeResult: 1,
            processMode: values.processMode,
            malfunctionDescribe: values.malfunctionDescribe,
            processor: values.processor,
            disposeResult: 1,
            processorTime: now
          }
          const header = {
            'Content-Type': 'application/json',
            Authorization: this.token
          }
          this.$http({
            url: this.modifyUrl,
            data: params,
            headers: header,
            method: 'put'
          }).then((data) => {
            // console.log(JSON.stringify(data))
            this.queryList()
            this.showdeal = false
            this.form.resetFields()
            this.$message.success('处理成功')
          })
        }
      })
    },
    handleDealCancel () {
      this.showdeal = false
    },
    handleOk () {
      this.visible = false
    },
    handleCancel (e) {
      this.visible = false
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
</style>
